import React from "react";
import { observer } from "mobx-react";
import { alertModalController } from "../modules/controllers";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

const AlertModal = observer(() => {
  const { getIsVisible, getMessage, hideMessage } = alertModalController;

  if (!getIsVisible) return null;

  return (
    <div
      className="alert-modal-backdrop"
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: 999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: 15,
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
          minWidth: 300,
          minHeight: 300,
          maxWidth: 500,
          overflowY: "auto",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "right",
            cursor: "pointer",
          }}
        >
          <CloseIcon onClick={hideMessage.bind(alertModalController)}>
            Close
          </CloseIcon>
        </div>
        <div style={{ minHeight: 300, display: "flex", alignItems: "center" }}>
          <p>{getMessage}</p>
        </div>
        <Button
          onClick={hideMessage.bind(alertModalController)}
          variant="contained"
        >
          OK
        </Button>
      </div>
    </div>
  );
});

export default AlertModal;
